import { ViewChild, ElementRef, ViewContainerRef, Component } from '@angular/core';
import { CtrlBaseComponent } from './ctrl-base.component';
import { DataType } from '../models/eDataType';
import { CtFormComponent } from './ct-form/ct-form.component';
import { FormControl, FormGroup } from '@angular/forms';
import { TooltipPosition } from '../enums/tooltipPosition';

@Component({
  selector: 'input-base',
  template: '',
  styles: ['']
})

export class InputBaseComponent extends CtrlBaseComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;

  private labelValue: string;
  private readOnly: boolean;
  private oneLineControl: boolean;
  //private value: string;
  private oldValue: string;
  private required: boolean;
  private requiredMessage: string;
  private tooltipMessage: string;
  private tooltipPosition : TooltipPosition = TooltipPosition.right;
  //private pickId: string;
  //private selectedAdn: ADN_PLUS;
  //private entityToDisplay: string;
  private initValue: any;
  private placeHolder: string = "";
  private ownerForm: CtFormComponent;
  private inputGroup: FormGroup;
  private formElement: FormControl;
  private length: number;
  private isFilterInput: boolean = false;
  private inputIcon : string = ''; //from metaData, specifies the icon that goes inside an input
  //isValid = if its required, the length of the input value must be more than 0. if its not required the isValid will be always true
  public isValid : boolean = true;
  //isActive = if the input was already used for search, the activate value will be true. 26/10/2022 (only applies for filter-container inputs).
  private isActive : boolean = false;

  constructor() {
    super();
    this.inputGroup = new FormGroup({});
  }

  ngOnInit() {
    super.ngOnInit();
    this.formElement = new FormControl({ value: this.getInitValue(), disabled: this.getReadOnly() });
    this.formElement.valueChanges.subscribe(newVal => this.setValue(newVal instanceof Array ? newVal[0] : newVal));
    this.inputGroup.controls[this.getModelId()] = this.formElement;
  }

  public get tooltipPositionEnum(): typeof TooltipPosition { 
    return TooltipPosition;
  }

  getLabelValue(): string { return this.labelValue }
  getPlaceHolder(): string { return this.placeHolder }
  getReadOnly(): boolean { return this.readOnly }
  getOneLineControl(): boolean { return this.oneLineControl }
  getValue(): any { return this.getFormGroup().value[this.getModelId()] }
  getOldValue(): any { return this.oldValue }
  getRequired(): boolean { return this.required }
  getRequiredMessage(): string { return this.requiredMessage }
  getTooltipMessage(): string { return this.tooltipMessage }
  //getPickId(): string { return this.pickId }
  //getSelectedAdn(): ADN_PLUS { return this.selectedAdn }
  //getEntityToDisplay(): string { return this.entityToDisplay }
  getInitValue(): any { return this.initValue }
  getTemplateRef(): ViewContainerRef { return this.target }
  getOwnerForm(): CtFormComponent { return this.ownerForm }
  getFormGroup(): FormGroup { return this.inputGroup }
  getFormControl(): FormControl { return this.formElement }
  getLength(): number { return this.length }
  getIsFilterInput(): boolean { return this.isFilterInput }
  getInputIcon(): string { return this.inputIcon }
  getIsValid(): boolean { return this.isValid }
  getIsActive(): boolean { return this.isActive };
  getTooltipPosition() : TooltipPosition { return this.tooltipPosition }

  setLabelValue(labelValue: string): void { this.labelValue = labelValue }
  setPlaceHolder(placeHolder: string): void { this.placeHolder = (placeHolder) ? placeHolder : "" }
  setReadOnly(readOnly: boolean): void { this.readOnly = readOnly }
  setOneLineControl(oneLineControl: boolean): void { this.oneLineControl = oneLineControl }
  setValue(value: any): void {
    if(value === 'null')
      value = null;
    

    if (value === this.getOldValue() || (value instanceof Array && this.getOldValue() instanceof Array && value[0] === this.getOldValue()[0]))
      return;

    if (!this.getFormControl())
      this.setInitValue(value);

    this.setOldValue(value);
    if (this.getCtType() != 'CtInputFile') {
      this.getFormGroup().patchValue({ [this.getModelId()]: value });
    }
    this.listenerAction(this, "value", value);
    this.onChange();
  }
  setOldValue(oldValue: any): void { this.oldValue = oldValue }
  setRequired(required: boolean): void { this.required = required }
  setRequiredMessage(requiredMessage: string): void { this.requiredMessage = requiredMessage }
  setTooltipMessage(tooltipMessage: string): void { this.tooltipMessage = tooltipMessage }
  //setPickId(pickId: string): void { this.pickId = pickId }
  //setSelectedAdn(selectedAdn: ADN_PLUS): void { this.selectedAdn = selectedAdn }
  //setEntityToDisplay(entityToDisplay: string): void { this.entityToDisplay = entityToDisplay }
  setInitValue(initValue: any): any { this.initValue = initValue }
  setOwnerForm(parent: CtFormComponent): void { this.ownerForm = parent }
  setFormGroup(inputGroup: FormGroup): void { this.inputGroup = inputGroup }
  setFormControl(formControl: FormControl): void { this.formElement = formControl }
  setLength(length: number) { this.length = length }
  setIsFilterInput(isFilterInput : boolean) { this.isFilterInput = isFilterInput }
  setInputIcon(icon: string) { this.inputIcon = icon }  
  setIsValid() { 
    let required = this.getMetaData().controlProperties.required;
    if(!required) {
      this.isValid = true;
      return;
    }
    if(this.getOldValue()!= undefined && (this.getOldValue()).toString().length > 0){ 
      this.isValid = true;
      return;
    } 
    this.isValid = false;
   }
  setIsActive(isActive : boolean): void { this.isActive = isActive }
  setTooltipPosition(tooltipPosition : TooltipPosition) : void { this.tooltipPosition = tooltipPosition }

  onClick(): void {
    //this.removeValidations();
    //if (!this.getPickId()) { return }
    // $('#' + this.getPickId()).modal();
  }

  /*removeValidations() {
    if (this['formControl']) {
      if ((this['formControl']['untouched'] || !this['formControl']['valid'])) {
        this.setRequired(false);
        if (this['formControl']['valueAccessor'])
          if (this.getCtType() !== 'CtInputNumber')
            this['formControl']['valueAccessor'].onTouched();
          else
            this['formControl']['valueAccessor']._onTouched();

      }
    }
  }*/

  /*saveValue() {
    // $('#' + this.getId()).data("oldValue", this.getValue());
  }*/

  /*compareValues(evt: any = null) {
    let vOldValue //= $('#' + this.getId()).data("oldValue");
    let vActualValue = this.getValue();

    if (vOldValue !== vActualValue)
      this.event2('onChange');
  }*/

  onEnter() {
    let ac = this.getEvent('onEnter');
    if (ac)
      this.executeAction2(ac);
  }

  onKeyUp(event: KeyboardEvent) {
    this.setIsValid();
    let ac = this.getEvent('onKeyUp');
    if (ac) {
      if (ac.utilParams && ac.utilParams.find(x => x.name.toUpperCase() === event.key.toUpperCase()))
        this.executeAction2(ac);
    }
  }

  public onChange(): void {
    if (!this.getValue())
      return;

    let ac = this.getEvent('onChange');

    if (ac && ac.utilParams && ac.utilParams.length > 0) {

      let vIgnore = false;

      for (let set of ac.utilParams) {
        if (set.dataSource === 'constant') {
          let field = set.name.split('=')[0];
          if (field === 'ignore') {

            let vValueToString = this.getValue() === null ? "null" : this.getValue().toString();

            vIgnore = vValueToString === set.name.split('=')[1] ? true : false;
          }

          if (vIgnore)
            return;
        }
      }
    }

    if (ac)
      this.executeAction2(ac);
  }

  public getInputDataType(): DataType {
    switch (this.getCtType()) {
      case 'CtInputDate':
        return DataType.DATE;
      case 'CtInputNumber':
        return DataType.NUMBER;
      default:
        return DataType.VARCHAR2
    }
  }

  public resetToInitState(): void {
    this.setProperties(this);
  }

  /*updateSelectedAdn(adn: ADN_PLUS): void {
    this.setSelectedAdn(adn);
    this.setValue(this.getAdnEntityValue(adn, this.getEntityToDisplay()));
  }*/

}




